import { render, staticRenderFns } from "./carduse.vue?vue&type=template&id=f24e56d2&scoped=true"
import script from "./carduse.vue?vue&type=script&lang=js"
export * from "./carduse.vue?vue&type=script&lang=js"
import style0 from "./carduse.vue?vue&type=style&index=0&id=f24e56d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24e56d2",
  null
  
)

export default component.exports